export interface CacheEntry {
  type: "data" | "promise";
  value: any;
  expiredAt: Date;
}

const isCacheValid = (cacheEntry: CacheEntry) => {
  const now = new Date().getTime();
  return cacheEntry.expiredAt.getTime() > now;

};

const inXMinutes = (offsetMinute: number): Date => {
  const X_MINUTES = offsetMinute * 60 * 1000;
  const now = new Date().getTime();
  return new Date(now + X_MINUTES);
};

export const wrapFetchValue = (state: any, key: string, fetchPromise: () => any, options: {
  expiredIn,
} = { expiredIn: 10 }): Promise<any> => {

  if (!state.cache) {
    state.cache = {};
  }

  const cacheEntry = state.cache[key];
  if (cacheEntry !== undefined && isCacheValid(cacheEntry)) {
    return cacheEntry.type === "promise" ? cacheEntry.value : Promise.resolve(cacheEntry.value);
  } else {
    const sendRequest = fetchPromise();
    state.cache[key] = {
      type: "promise", value: sendRequest, expiredAt: inXMinutes(options.expiredIn),
    };
    return sendRequest
      .then((value) => {
        state.cache[key] = {
          type: "data", value, expiredAt: inXMinutes(options.expiredIn),
        };
        return value;
      }).catch((error) => {
        delete state.cache[key];
        throw error;
      });
  }

};

export const clearCache = (state: any, key: string): void => {
  if (state.cache && state.cache[key]) {
    delete state.cache[key];
  }
};
